import React from "react";
import "./StatusBadge.css";

const StatusBadge = ({
  isActive,
  onClick,
  disabled = false,
  activeLabel = "Active",
  inactiveLabel = "InActive",
}) => {
  const label = isActive ? activeLabel : inactiveLabel;
  const title = disabled
    ? label
    : isActive
      ? `Click to set ${inactiveLabel}`
      : `Click to set ${activeLabel}`;

  return (
    <button
      type="button"
      className={`status-badge ${
        isActive ? "status-badge--active" : "status-badge--inactive"
      }`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      title={title}
    >
      {label}
    </button>
  );
};

export default StatusBadge;
